var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-aside",
    {
      staticClass: "ms-aside-container",
      style: { "margin-left": !_vm.asideHidden ? 0 : "-" + _vm.currentWidth },
      attrs: { width: _vm.currentWidth },
    },
    [
      _vm._t("default"),
      _vm.isSystem
        ? _c("de-horizontal-drag-bar", { attrs: { type: _vm.type } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }